import React, { useState, createContext, useContext, ReactNode, Dispatch, SetStateAction } from 'react';


// Define the shape of the context
interface ModalStateContextType {
  title: string;
  setTitle: Dispatch<SetStateAction<string>>;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

// Provide a default value matching the shape of the context
const ModalStateContext = createContext<ModalStateContextType>({ 
  title: '',
  setTitle: () => {},
  open: false,
  setOpen: () => {},
});

export const useModalState = () => useContext(ModalStateContext);

interface ModalStateProviderProps {
  children: ReactNode; // This defines the types for children prop to be ReactNode which is more accurate
}
export const ModalStateProvider: React.FC<ModalStateProviderProps> = ({ children }) => {
  const [title, setTitle] = useState<string>('Default Title');
  const [open, setOpen] = useState<boolean>(false);

  return (
    <ModalStateContext.Provider value={{ title, setTitle, open, setOpen }}>
      {children}
    </ModalStateContext.Provider>
  );
};
